import { z } from 'zod';

export const CompetenceSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1, "Competency Name is required"),
    description: z.string().optional(),
    level: z.string().optional(),
    numberOfPersonnel: z.number().default(0),
    status: z.string().default('active'),
    createdAt: z.union([z.string(), z.date()]).optional(),
    updatedAt: z.union([z.string(), z.date()]).optional(),
});
export const CreateCompetenceSchema = CompetenceSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateCompetenceSchema = CompetenceSchema.partial();
export const CompetenceFormSchema = CompetenceSchema;
